<template>
  <div :class="`component__carousel--${props.iteration}`">
    <img class="right" :src="`${pre}side-gradient.svg`" />
    <img class="left" :src="`${pre}side-gradient.svg`" />
    <div class="carousel__bg">
      <div class="carousel__wrapper">
        <div :class="carouselIteration">
          <div
            class="carousel__product"
            v-for="(item, key) in carousel[props.iteration]"
            :key="item"
          >
            <div style="margin-top: 40px">
              <img class="carousel__img--product opacity--0" :src="pre + item.img" />
            </div>
            <div class="carousel__h1 px--20">
              <div class="first" v-html="item.title + item.title2"></div>
              <div class="abv">{{ item.abv }}</div>
            </div>
            <button
              class="carousel__button"
              data-action="csWidgetOpen"
              :data-id="key"
              @click="showModal($event)"
            >
              <img :src="`${pre}buy.png`" style="max-width: 200px; margin-top: 35px" />
            </button>
          </div>
        </div>
      </div>
      <img :src="`${pre}table.jpg`" class="carousel__surface" />
      <img :src="`${pre}hero/Gold_border.jpg`" class="gold-border" />
    </div>
  </div>
</template>

<script setup>
import dataModel from "../js/model.js";
import gsap from "gsap";
const props = defineProps({
  iteration: {
    type: String,
    default: "1",
  }, 
  pre: {
    type: String,
    default: "1",
  }, 
});
var carouselIteration = "carousel--" + props.iteration;
var carousel = {
  1: {
    1: {
      title: "Captain Morgan sLICED APPLE Rum ",
      title2: "Flavoured&nbsp;Spirit",
      img: "products/prod-3.png",
      url: "",
      abv: "70cl, 25% ABV",
    },
    2: {
      title: "Captain Morgan Original ",
      title2: "Spiced Gold Rum Flavoured&nbsp;Spirit",
      img: "products/prod-1.png",
      url: "",
      abv: "70cl, 35% ABV",
    },
    3: {
      title: "Captain Morgan TIKI ",
      title2: "Flavoured&nbsp;Spirit",
      img: "products/prod-2.png",
      url: "",
      abv: "70cl, 25% ABV",
    },
    4: {
      title: "Captain Morgan Original ",
      title2: "Spiced Gold Rum Flavoured&nbsp;Spirit",
      img: "products/prod-4.png",
      url: "",
      abv: "1l, 35% ABV",
    },
    5: {
      title: "Captain Morgan dark rum",
      title2: "Flavoured&nbsp;Spirit",
      img: "products/prod-5.png",
      url: "",
      abv: "1l, 35% ABV",
    },
    6: {
      title: "Captain Morgan dark rum",
      title2: "Flavoured&nbsp;Spirit",
      img: "products/prod-6.png",
      url: "",
      abv: "70cl, 35% ABV",
    },
    7: {
      title: "Captain Morgan white rum",
      title2: "Flavoured&nbsp;Spirit",
      img: "products/prod-7.png",
      url: "",
      abv: "1l, 35% ABV",
    },
    8: {
      title: "Captain Morgan white rum",
      title2: "Flavoured&nbsp;Spirit",
      img: "products/prod-8.png",
      url: "",
      abv: "70cl, 35% ABV",
    },
    9: {
      title: "Captain Morgan ",
      title2: "original spiced gold &&nbsp;cola",
      img: "products/prod-9.png",
      url: "",
      abv: "250ml, 5% ABV",
    },
    10: {
      title: "Captain Morgan",
      title2: "original spiced gold &&nbsp;cola",
      img: "products/prod-10.png",
      url: "",
      abv: "330ml, 10% ABV",
    },
  },
};
$(document).ready(function () {
  $("." + carouselIteration)
    .closest(".carousel__wrapper")
    .prepend(
      `<div class="carousel__previous--${props.iteration}"><img class="carousel__previous--${props.iteration}" src="${props.pre}prev.svg" width="40" style="position: absolute;top: calc(50% - 18px);z-index: 1150;left: 20px; font-family:CaptainRefined, sans-serif;"><span style="position: absolute;
  left: 20px;
  top: 51%;
  font-family: CaptainRefined, sans-serif;
  color: white;
  font-weight: 100;
  font-size: 14px;" id="prev-txt">PREV</span></div>`
    );
  $("." + carouselIteration)
    .closest(".carousel__wrapper")
    .append(
      `<div class="carousel__previous--${props.iteration}" id="prev"><img class="carousel__next--${props.iteration}" id="next" src="${props.pre}next.svg" width="40" style="position: absolute;top: calc(50% - 18px);z-index: 1150;right: 20px;font-family:CaptainRefined, sans-serif;"><span style="position: absolute;
  right: 20px;
  top: 51%;
  font-family: CaptainRefined, sans-serif;
  color: white;
  font-weight: 100;
  font-size: 14px;" id="next-txt">NEXT</span></div>`
    );

  $("." + carouselIteration).slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $(".carousel__previous--" + props.iteration),
    nextArrow: $(".carousel__next--" + props.iteration),
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1650,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1130,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.right {
  position: absolute;
  right: 0;
  // top: 0;
  height: 0px;
  z-index: 10;
}
.left {
  position: absolute;
  left: 0;
  // top: 0;
  height: 0px;
  z-index: 10;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.carousel__next--1 {
  -webkit-animation: pulse 3s linear infinite;
  animation: pulse 3s linear infinite;
}
.carousel__previous--1 {
  -webkit-animation: pulse 3s linear infinite;
  animation: pulse 3s linear infinite;
}
.next-txt {
  -webkit-animation: pulse 3s linear infinite;
  animation: pulse 3s linear infinite;
}
.prev-txt {
  -webkit-animation: pulse 3s linear infinite;
  animation: pulse 3s linear infinite;
}

.component__carousel--1 {
  *:focus {
    outline: 0 !important;
  }
  .carousel__bg {
    height: 800px;
    position: relative;

    @media screen and(max-width: 321px) {
      background-size: 350%;
    }
  }

  .carousel__wrapper {
    height: 100%;
    margin: auto;
    padding-top: 70px;
    position: relative;
    text-align: center;
    width: 100%;
    z-index: 100;
  }
  .carousel {
    width: 100%;
    margin: 0px auto;
  }
  .carousel__product {
    padding: 0px 20px;
    width: 100%;
  }
  .wrapper .slick-dots li button:before {
    font-size: 20px;
    color: #000000;
  }
  .slick-arrow:before {
    color: #ffffff;
  }

  .carousel__h1 {
    color: #ffffff;
    font-size: 22px;
    font-weight: 100;
    height: 70px;
    letter-spacing: 0px;
    line-height: 28px;
    margin-top: -70px;
    margin-bottom: 28px;
    margin-top: -55px;
  }
  .first,
  .second,
  .abv {
    font-weight: 100 !important;
  }

  .carousel__img--product {
    margin: auto;
    max-width: 150px;
    width: 100%;
  }
  .carousel__surface {
    background-size: cover;
    left: 0;
    bottom: 0px;
    height: 350px;
    position: absolute;
    width: 102%;
    margin-left: -5px;
  }
}
@media screen and(max-width: 640px) {
  .right {
    height: 930px !important;
    bottom: 435px !important;
    z-index: 10 !important;
    z-index: 10 !important;
  }
  .left {
    height: 930px;
    bottom: 435px;
    z-index: 10;
    z-index: 10;
  }
}
@media screen and(max-width: 600px) {
  .carousel__bg {
    background-size: 320%;
    height: 660px;
  }
  .carousel__img--product {
    max-width: 120px;
  }

  .carousel__img--product {
    max-width: 120px;
  }
  .carousel__wrapper {
    padding-top: 20px !important;
  }
}

@-webkit-keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
